module.exports = __webpack_public_path__ + "static/media/icon-01.0271d2b6.png";